import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { isEmail } from '../utils/utils'

class ForgetPassword extends Component {
  constructor (props) {
    super(props)
    this.state = {
      email: ''
    }
    this.onSubmit = this.onSubmit.bind(this)
  }

  onSubmit (e) {
    e.preventDefault()
    const credentials = {
      email: this.state.email
    }
    this.props.requestRecover(credentials)
  }

  render () {
    const { className, isProcessing, message } = this.props
    return (
      <div className={className}>
        <h1 className='main-panel__heading'>
          Recuperação de Senha
          <small className='main-panel__subheading'>Entre com o seu email abaixo</small>
        </h1>
        {(message !== '') ? <div>{message}</div> : (
          <form onSubmit={this.onSubmit} name='form'>
            <div className='input__group'>
              <label>Email</label>
              <input
                value={this.state.email}
                onChange={e => this.setState({ email: e.target.value })}
                type='email'
                className='form-control'
                placeholder='Email'
                required=''
              />
            </div>
            <div className='has-text-centered'>
              <button className='button is-primary' type='submit' disabled={!isEmail(this.state.email) || isProcessing}>
                {isProcessing ? 'Carregando...' : 'Enviar'}
              </button>
            </div>
          </form>
        )}
        <div className='has-text-centered'>
          <Link to='login'>Retornar ao login</Link>
        </div>
      </div>
    )
  }
}

ForgetPassword.propTypes = {
  className: PropTypes.string,
  isProcessing: PropTypes.bool,
  message: PropTypes.string,
  requestRecover: PropTypes.func
}

export default ForgetPassword



// WEBPACK FOOTER //
// ./src/components/ForgetPassword.js